angular.module('assets')
    .controller('AssetDocumentCancelController', function ($rootScope, $uibModalInstance, toastr, data, AssetDocument) {
        this.$onInit = () => {
            this.item = data;
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            return AssetDocument.cancel({id: this.item.id}).$promise.then(result => {
                $rootScope.$broadcast('asset-doc.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            });
        }
    })
